import * as R from "ramda";

import ocClient from "services/ocClient";

import * as Vault from "./vault";

const getWrappingToken = R.path(["wrap_info", "token"]);
const getToken = R.path(["auth", "client_token"]);
let endpoint;

export function configVault(config) {
  endpoint = config.endpoint;
}

export function getVaultAddr() {
  return endpoint;
}

export async function fetchVaultToken() {
  const { data: wrappedTokenResponse } = await ocClient.post("/api/vault/tokens");
  const wrappingToken = getWrappingToken(wrappedTokenResponse);

  const unwrappedTokenResponse = await Vault.unwrap({
    token: wrappingToken,
    addr: endpoint,
  });
  const token = getToken(unwrappedTokenResponse);

  const lookupSelfResponse = await Vault.tokenLookupSelf({ token, addr: endpoint });
  const {
    data: { entity_id: entityId },
  } = lookupSelfResponse;

  return { token, entityId };
}
